import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface CarryStat {
  icon: LucideIcon;
  label: string;
  value: ReactNode;
  hint?: ReactNode;
  highlight?: boolean;
}

export function CarryStatStrip({ stats }: { stats: CarryStat[] }) {
  return (
    <div className="grid grid-cols-2 gap-4 py-2 sm:flex sm:flex-wrap sm:items-center sm:gap-x-8 sm:gap-y-4">
      {stats.map((stat, index) => (
        <div key={stat.label} className="flex items-center gap-8">
          <div className="flex items-center gap-3">
            <stat.icon className="h-4 w-4 flex-shrink-0 text-muted-foreground" />
            <div className="flex min-w-0 flex-col">
              <span className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
                {stat.label}
              </span>
              <span className="flex items-baseline gap-1.5">
                <span
                  className={cn(
                    'whitespace-nowrap text-lg font-semibold text-foreground',
                    stat.highlight && 'text-orange-600 dark:text-orange-400'
                  )}
                >
                  {stat.value}
                </span>
                {stat.hint && (
                  <span className="whitespace-nowrap text-xs text-muted-foreground">
                    {stat.hint}
                  </span>
                )}
              </span>
            </div>
          </div>
          {index < stats.length - 1 && (
            <div className="hidden h-8 w-px flex-shrink-0 bg-border sm:block" />
          )}
        </div>
      ))}
    </div>
  );
}
